import { render, staticRenderFns } from "./RecuperarSenhaNovaSenha.vue?vue&type=template&id=c3a9258c&scoped=true"
import script from "./RecuperarSenhaNovaSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaNovaSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaNovaSenha.vue?vue&type=style&index=0&id=c3a9258c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a9258c",
  null
  
)

export default component.exports